export const ACTION_RESET = 'FETCH_STORYSLIDER_RESET';
export const ACTION_REQUEST = 'FETCH_STORYSLIDER_REQUEST';
export const ACTION_SUCCESS = 'FETCH_STORYSLIDER_SUCCESS';
export const ACTION_ERROR = 'FETCH_STORYSLIDER_ERROR';
